import React, { useState, useEffect } from 'react';

import './styles.css';

import callListServices from '../../../../../services/academy/callListServices';
import classServices from '../../../../../services/academy/classServices';

import compare from '../../../../../functions/compare';

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import SelectGroup from '../../../../../components/SelectGroup';
import UserPhoto from '../../../../../components/UserPhoto';
import ActivityIndicator from '../../../../../components/ActivityIndicator';
import { FaClipboardList } from 'react-icons/fa';
import Notice from '../../../../../components/Notice';
import { Dots } from 'react-activity';

function PopupNewCallList(props) {
    const [type, setType] = useState("");
    const [time, setTime] = useState("00:00");
    const [classStudents, setClassStudents] = useState([]);
    const [selectList, setSelectList] = useState([]);
    const [hideList] = useState([]);
    const [fetchingRead, setFetchingRead] = useState(false);
    const [fetchingCreate, setFetchingCreate] = useState(false);

    useEffect(() => {
        const dateNow = new Date()
        setTime(`${String(dateNow.getHours()).padStart(2, '0')}:${String(dateNow.getMinutes()).padStart(2, '0')}`)
    }, [props.visibility]);

    useEffect(() => {
        if (props.data && props.data.classId) {
            setType("Treino");
            setTime(props.data.time);

            readClassStudents();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data]);

    async function readClassStudents() {
        setFetchingRead(true);
        const response = await classServices.getClassStudents(props.data.classId);
        setFetchingRead(false);
        if (response.status === 200) {
            setClassStudents(response.data.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`)));
        } else
            alert("Erro ao ler alunos da turma, tente novamente!");
    }

    async function createCallList() {
        setFetchingCreate(true);
        let response = await callListServices.postCallList(
            (props.data && props.data.classId ? props.data.classId : props.classId),
            type[0],
            time,
            (props.data && props.data.trainingId ? props.data.trainingId : null)
        );
        if (response.status === 201) {
            const callListId = response.data.id;
            response = await callListServices.postGroupCheckin(
                (props.data && props.data.classId ? props.data.classId : props.classId),
                callListId,
                selectList.map((item) => ({ "aluno": (props.data ? classStudents : props.classStudents)[item].id }))
            );
            if (response.status === 204) {
                props.setVisibility(false);
                setSelectList([]);
            } else
                alert("Erro ao registrar presenças, verifique a lista criada!");
            props.onCreate();
        } else
            alert("Erro ao criar lista de chamada, tente novamente!");
        setFetchingCreate(false);
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaClipboardList />}
            tittle='Nova lista de chamada'
        >
            {
                fetchingRead ?
                    <ActivityIndicator />
                    :
                    (

                        (props.classStudents !== undefined && props.classStudents.length > 0) || (props.data && classStudents.length > 0) ?
                            <>
                                {
                                    props.data ?
                                        <span className='popup-new-call-list-tag'>
                                            {props.data ? props.data.type : 'Sem tipo'} - {props.data ? props.data.dateTime : "Data e hora não especificada"}
                                        </span>
                                        :
                                        <form>
                                            <div className='line'>
                                                <Input
                                                    label='Atividade'
                                                    type='select'
                                                    options={['Treino', 'Jogo treino']}
                                                    id='class-new-call-list-type'
                                                    onChange={(event) => setType(event.target.value)}
                                                    value={type}
                                                />
                                                <Input
                                                    label='Início'
                                                    type='time'
                                                    id='class-new-call-list-time'
                                                    onChange={(event) => setTime(event.target.value)}
                                                    value={time}
                                                />
                                            </div>
                                        </form>
                                }
                                {
                                    props.classStudents || props.data ?
                                        <>
                                            <SelectGroup
                                                showInfos
                                                tittle='Selecione os alunos presentes'
                                                itemType='alunos'

                                                hides={hideList}
                                                markeds={selectList}
                                                setMarkeds={setSelectList}
                                            >
                                                {
                                                    (props.data ? classStudents : props.classStudents).map((item, index) =>
                                                        <div key={item.id} className='popup-new-call-list-select-group'>
                                                            <UserPhoto src={item.foto} />
                                                            <p><b>{`${item.nome} ${item.sobrenome}`}</b></p>
                                                        </div>
                                                    )
                                                }
                                            </SelectGroup>
                                            <button className='pink' onClick={createCallList}>
                                                {
                                                    fetchingCreate ?
                                                        <Dots />
                                                        : "Registrar"
                                                }
                                            </button>
                                        </>
                                        : []
                                }
                            </>
                            :
                            <Notice>Não é possível criar uma lista de chamada vazia. Registre alunos na turma antes.</Notice>
                    )
            }
        </Popup>
    )
}

export default PopupNewCallList;